<div class="widget-map-container" [ngClass]="{'full-height': widgetType === 'wm-form'}">
    <div class="row field-heading">
        <div class="col-xs-1"><input class="app-checkbox" type="checkbox"
                [ngModel]="currentStep.componentDefnObject?.isSelectAll"
                (ngModelChange)="selectAllFields.emit($event)" /></div>
        <div class="col-xs-3"><label>{{locale.LABEL_WIDGET_DESIGNER_FIELD}}</label></div>
        <div class="col-xs-3"><label>{{locale.LABEL_WIDGET_DESIGNER_TITLE}}</label></div>
        <div class="col-xs-3"><label>{{locale.LABEL_VIEW_AS}}</label></div>
    </div>
    <div class="field-map wm-table-container" id="widgetFieldMap">
        <div class="angular-ui-tree">
            <ol class="list-items angular-ui-tree-nodes">
                <li *ngFor="let field of currentStep?.primitiveTypes; index as i"
                    [ngClass]="{'active': field === currentStep.selectedComponent.field}" class="list-item first-level">
                    <wms-fields-list [id]="'field-' + i" [level]="i+1" [field]="field" [currentStep]="currentStep"
                        [fieldTypeWidgetTypeMap]="fieldTypeWidgetTypeMap" [otherWdgts]="otherWdgts" [myWidgets]="myWidgets"
                        (updateSelectAll)="updateSelectAll.emit($event)" (toggleInnerFields)="toggleInnerFields.emit($event)"
                        (updateSelectedComponent)="updateSelectedComponent.emit($event)"
                        (onWidgetTypeChange)="onWidgetTypeChange.emit($event)"></wms-fields-list>
                </li>
            </ol>
        </div>

        <div *ngFor="let column of currentStep?.columns">
            <div *ngIf="!currentStep.hideHeaders" title="{{column.title}}">
                <div class="column-title"><span class="text">{{column.title}}</span></div>
            </div>
            <div class="angular-ui-tree">
                <ol class="list-items angular-ui-tree-nodes">
                    <li *ngFor="let field of column.fields; index as i"
                        [ngClass]="{'active': field === currentStep.selectedComponent.field }"
                        class="list-item first-level">
                        <wms-fields-list [id]="'col-' + i" [level]="i+1" [field]="field" [currentStep]="currentStep"
                            [fieldTypeWidgetTypeMap]="fieldTypeWidgetTypeMap" [otherWdgts]="otherWdgts" [myWidgets]="myWidgets"
                            (updateSelectAll)="updateSelectAll.emit($event)" (toggleInnerFields)="toggleInnerFields.emit($event)"
                            (updateSelectedComponent)="updateSelectedComponent.emit($event)"
                            (onWidgetTypeChange)="onWidgetTypeChange.emit($event)"></wms-fields-list>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</div>
